/**
 * Columna «Quién» de las listas de Compras y Gastos: quién registró el documento y quién lo resolvió
 * (aprobó, confirmó, envió a aprobación, canceló o anuló).
 *
 * Decisiones de diseño, acordadas con el dueño sobre la vista previa del 2026-09-07:
 * - El NOMBRE va en una sola línea horizontal, nunca partido en varios renglones (`white-space: nowrap`
 *   en `.who-stack__row`). Si un nombre no cupiera, se recorta con «…» y el completo queda en el
 *   `title` — bajar a otro renglón se leía mal en la tabla.
 * - Quien no se registró se dice «Sin dato», no se deja en blanco ni se inventa: las compras
 *   resueltas antes de que se empezara a guardar la autoría no tienen ese dato.
 * - Mismo componente en las dos pantallas para que compras y gastos no acaben con vocabularios
 *   distintos para lo mismo.
 */
export interface WhoEntry {
  /** Verbo en pasado, tal como lo lee una persona: «Registró», «Aprobó», «Canceló». */
  label: string;
  name: string | null | undefined;
}

export function WhoStack({ entries }: { entries: WhoEntry[] }) {
  const visible = entries.filter((entry) => entry.label);
  if (!visible.length) return null;
  return <div className="who-stack">{visible.map((entry) => (
    <div className="who-stack__row" key={entry.label}>
      <span className="who-stack__label">{entry.label}</span>
      {entry.name
        ? <span className="who-stack__name" title={entry.name}>{entry.name}</span>
        : <span className="who-stack__name"><span className="who-stack__none">Sin dato</span></span>}
    </div>
  ))}</div>;
}
